import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionAtencionEditarComponent {
  atencionId
  clienteId
  onClose
  editando = false

  constructor (ClienteInformacionAtencionCliente) {
    this.ClienteInformacionAtencionClienteService = ClienteInformacionAtencionCliente
  }

  $onInit () {
    this.promise = this.ClienteInformacionAtencionClienteService.get(this.clienteId, this.atencionId)
      .then(({data}) => (this.data = data))
  }

  editar (item) {
    this.editando = false
    if (item.exito) {
      this.onClose({$event: {detail: this.data}})
    }
  }

  cerrar () {
    this.onClose({$event: {detail: null}})
  }

  actualizarNotificaciones () {
    if (!this.data.correo) this.data.notificaciones.correo = false
  }
}

module.component('clienteInformacionAtencionEditar', {
  controller: ClienteInformacionAtencionEditarComponent,
  template,
  bindings: {
    clienteId: '<',
    atencionId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/atencion/editar/component.js